module.exports = __webpack_public_path__ + "img/nuestra-familia.aa49cca9.png";